import { ReactNode } from 'react';
import { ErrorBoundary } from '@sentry/react';
import { Button, Result } from 'antd';
import { Trans } from '@lingui/macro';

import styles from './AppErrorBoundary.module.scss';

type Props = {
  children: ReactNode;
};

type FallbackProps = {
  eventId: string | null;
  resetError: () => void;
};

const Fallback = ({ eventId, resetError }: FallbackProps) => (
  <div className={styles.container}>
    <Result
      status="error"
      title={<Trans>Something went wrong</Trans>}
      subTitle={
        <Trans>
          An unexpected error occurred. Our team has been notified. Please try again.
        </Trans>
      }
      extra={
        <div className={styles.actions}>
          <Button type="primary" onClick={resetError}>
            <Trans>Try again</Trans>
          </Button>
          <Button onClick={() => window.location.assign('/')}>
            <Trans>Go to home</Trans>
          </Button>
        </div>
      }
    />
    {eventId && (
      <div className={styles.eventId}>
        <Trans>Error ID: {eventId}</Trans>
      </div>
    )}
  </div>
);

export const AppErrorBoundary = ({ children }: Props) => (
  <ErrorBoundary
    fallback={({ eventId, resetError }) => (
      <Fallback eventId={eventId} resetError={resetError} />
    )}
  >
    {children}
  </ErrorBoundary>
);
